import { DateTime } from 'luxon';

import { PERIOD_OPTIONS } from '../constants/index';

export const useDateFormatPeriod = () => {
  const handleDateCalculation = (
    daterange: number,
    period: string,
    preCalculatedDate: DateTime
  ) => {
    if (period === 'days') {
      return preCalculatedDate.minus({ days: daterange });
    }
    return daterange > 1
      ? preCalculatedDate.plus({ [period]: daterange }).endOf(period as any)
      : preCalculatedDate.endOf(period as any);
  };

  const getPeriodFormatted = (period: string, daterange = 1) => {
    const yesterday = DateTime.local().minus({ day: 1 });
    let start: any;
    let end: any;
    let initialPeriod: any;
    let preCalculatedDate;

    switch (period) {
      // ADDON SPECIFIC TIME RANGE STARTS
      case PERIOD_OPTIONS.yesterday:
        start = yesterday;
        end = yesterday;
        initialPeriod = PERIOD_OPTIONS.custom;
        break;

      case PERIOD_OPTIONS.day:
        start = handleDateCalculation(daterange - 1, 'days', yesterday);
        end = yesterday;
        if (daterange === 28) {
          initialPeriod = PERIOD_OPTIONS.last28Days;
        } else if (daterange === 14) {
          initialPeriod = PERIOD_OPTIONS.last14Days;
        } else if (daterange === 7) {
          initialPeriod = PERIOD_OPTIONS.last7Days;
        } else {
          initialPeriod = PERIOD_OPTIONS.custom;
        }
        break;

      case PERIOD_OPTIONS.week:
        preCalculatedDate = yesterday
          .minus({ week: daterange })
          .startOf('week');
        start = preCalculatedDate.minus({ day: 1 });
        end = handleDateCalculation(daterange, 'week', preCalculatedDate);
        end = end.minus({ day: 1 });
        initialPeriod =
          daterange === 1 ? PERIOD_OPTIONS.lastWeek : PERIOD_OPTIONS.custom;
        break;

      case PERIOD_OPTIONS.month:
        preCalculatedDate = yesterday
          .minus({ month: daterange })
          .startOf('month');
        start = preCalculatedDate;
        end = handleDateCalculation(daterange - 1, 'month', preCalculatedDate);
        initialPeriod =
          daterange === 1 ? PERIOD_OPTIONS.lastMonth : PERIOD_OPTIONS.custom;
        break;

      case PERIOD_OPTIONS.quarter:
        preCalculatedDate = yesterday
          .minus({ quarter: daterange })
          .startOf('quarter');
        start = preCalculatedDate;
        end = handleDateCalculation(daterange, 'quarter', preCalculatedDate);
        initialPeriod =
          daterange === 1 ? PERIOD_OPTIONS.lastQuarter : PERIOD_OPTIONS.custom;
        break;

      case PERIOD_OPTIONS.year:
        preCalculatedDate = yesterday
          .minus({ year: daterange })
          .startOf('year');
        start = preCalculatedDate;
        end = handleDateCalculation(daterange, 'year', preCalculatedDate);
        initialPeriod = PERIOD_OPTIONS.custom;
        break;
      // ADDON SPECIFIC TIME RANGE ENDS

      case PERIOD_OPTIONS.lastWeek:
        start = yesterday.minus({ week: 1 }).startOf('week');
        end = start.endOf('week').minus({ day: 1 });
        start = start.minus({ day: 1 });
        initialPeriod = PERIOD_OPTIONS.lastWeek;
        break;

      case PERIOD_OPTIONS.last7Days:
        start = yesterday.minus({ day: 7 });
        end = yesterday;
        initialPeriod = PERIOD_OPTIONS.last7Days;
        break;

      case PERIOD_OPTIONS.last14Days:
        start = yesterday.minus({ week: 2 }).plus({ day: 1 });
        end = yesterday;
        initialPeriod = PERIOD_OPTIONS.last14Days;
        break;

      case PERIOD_OPTIONS.last28Days:
        end = yesterday;
        start = end.minus({ days: 27 });
        initialPeriod = PERIOD_OPTIONS.last28Days;
        break;

      case PERIOD_OPTIONS.lastMonth:
        start = yesterday.minus({ month: 1 }).startOf('month');
        end = start.endOf('month');
        initialPeriod = PERIOD_OPTIONS.lastMonth;
        break;

      case PERIOD_OPTIONS.lastQuarter:
        start = yesterday.minus({ quarter: 1 }).startOf('quarter');
        end = start.endOf('quarter');
        initialPeriod = PERIOD_OPTIONS.lastQuarter;
        break;

      case PERIOD_OPTIONS.lifetime:
        initialPeriod =
          PERIOD_OPTIONS.lifetime.charAt(0).toUpperCase() +
          PERIOD_OPTIONS.lifetime.slice(1);
        break;
      default:
        break;
    }

    return {
      start: DateTime.fromISO(start).toFormat('yyyy-MM-dd'),
      end: DateTime.fromISO(end).toFormat('yyyy-MM-dd'),
      period: initialPeriod,
    };
  };

  return { getPeriodFormatted };
};
